import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import Greetings from './Greeting/Greetings';
import ListaFacturas from './ListaFacturas';


const Facturas = () => {

    const [showNuevaFactura, SetShowNuevaFactura] = React.useState(false);



    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {



    }, []);


    return (
        <>

            <Row>
                <Col className="col-12">
                    <Greetings />
                </Col>
                <Col className="col-12">
                    <ListaFacturas
                        SetShowNuevaFactura={SetShowNuevaFactura}
                        showNuevaFactura={showNuevaFactura}
                    />
                </Col>

            </Row>

        </>
    );
};

export default Facturas;